/* ---------- The Early Duck moment: the page blurs, the count turns, the badge arrives ---------- */
(() => {
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const fmt = n => Math.round(n).toLocaleString("en-US");
  const today = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short", year: "numeric" }).format(new Date());
  $$("#moment [data-date]").forEach(el => el.textContent = today);

  const moment = $("#moment"), counter = $("#counter"), stage = $("#mStage"), closeBtn = $("#mClose");
  const badge = $("#edBadge"), card = $("#edCard"), floor = $("#edFloor");
  const sweep = () => { badge.classList.remove("sweeping"); void badge.offsetWidth; badge.classList.add("sweeping"); };
  let timers = [], returnFocus = null;
  const later = (ms, fn) => timers.push(setTimeout(fn, reduced ? 0 : ms));

  function setNumber(no) {
    $$("#moment [data-n]").forEach(el => el.textContent = fmt(no));
    $$("#moment [data-n4]").forEach(el => el.textContent = String(no).padStart(4, "0"));
  }
  function show() {
    returnFocus = document.activeElement;
    moment.hidden = false; closeBtn.hidden = false; document.documentElement.style.overflow = "hidden";
    requestAnimationFrame(() => moment.classList.add("on"));
  }
  function bringCard() {
    stage.hidden = false; spin = 0; target = 0; vel = 0;
    badge.classList.remove("entering"); void badge.offsetWidth; badge.classList.add("entering");
    requestAnimationFrame(() => stage.classList.add("in")); touchedAt = performance.now();
  }
  /* from: the count before this person; to: their number. onLand runs as the number lands (the site's own count and dot) */
  function open(from, to, onLand) {
    timers.forEach(clearTimeout); timers = [];
    setNumber(to); show();
    counter.classList.remove("out", "show"); stage.hidden = true; stage.classList.remove("in");
    buildOdo(from); $("#bigCount").textContent = fmt(from);
    ["#bloom", "#rip1", "#rip2"].forEach(q => $(q).classList.remove("on")); $("#odo").classList.remove("land"); $("#youLine").classList.add("hide");
    later(250, () => counter.classList.add("show"));
    later(900, () => rollOdo(from, to));
    later(2400, () => {
      $("#odo").classList.add("land"); ["#bloom", "#rip1", "#rip2"].forEach(q => $(q).classList.add("on"));
      $("#youLine").classList.remove("hide"); $("#bigCount").textContent = "You are Early Duck number " + fmt(to);
      if (onLand) onLand();
    });
    later(4200, () => counter.classList.add("out"));
    later(4750, bringCard);
    later(5900, () => { sweep(); closeBtn.focus({ preventScroll: true }); });
  }
  /* back to the badge later, straight to the card */
  function reopen() {
    timers.forEach(clearTimeout); timers = [];
    show(); counter.classList.remove("show"); counter.classList.add("out");
    bringCard(); later(900, sweep);
  }
  function close() {
    timers.forEach(clearTimeout); timers = [];
    moment.classList.remove("on"); closeBtn.hidden = true; document.documentElement.style.overflow = "";
    setTimeout(() => { moment.hidden = true; }, reduced ? 0 : 450);
    if (returnFocus && returnFocus.focus) returnFocus.focus({ preventScroll: true });
  }
  closeBtn.addEventListener("click", close);
  $("#mBack").addEventListener("click", close);
  // a tap on the blurred background around the card and panel also goes back to the site
  moment.addEventListener("click", e => { if (!stage.hidden && (e.target === moment || e.target === stage)) close(); });
  addEventListener("keydown", e => { if (e.key === "Escape" && !moment.hidden) close(); });

  /* the number: one column per digit, each a strip of 0–9 twice; changed digits move one step */
  function buildOdo(n) {
    const odo = $("#odo"); odo.innerHTML = "";
    String(n).split("").forEach(ch => {
      const col = document.createElement("span"); col.className = "col";
      const strip = document.createElement("span"); strip.className = "strip";
      for (let k = 0; k < 20; k++) { const d = document.createElement("span"); d.className = "d"; d.textContent = k % 10; strip.appendChild(d); }
      strip.style.transform = `translateY(${-(+ch)}em)`;
      col.appendChild(strip); odo.appendChild(col);
    });
  }
  function rollOdo(from, to) {
    const a = String(from).padStart(String(to).length, "0"), b = String(to);
    if (a.length !== $("#odo").children.length) buildOdo(+a);
    [...$("#odo").children].forEach((col, i) => {
      if (a[i] === b[i]) return;
      const strip = col.firstChild, end = (+b[i] < +a[i] ? 10 : 0) + +b[i];
      if (reduced) { strip.style.transform = `translateY(${-end}em)`; return; }
      strip.classList.remove("rolling"); void strip.offsetWidth; strip.classList.add("rolling");
      strip.style.transform = `translateY(${-end}em)`;
    });
  }

  /* personalising: the name writes onto the card as it is typed */
  const nameEls = $$("#moment [data-name]"), nameBack = $("#moment [data-name-back]");
  function setName(v) {
    const n = v.trim();
    nameEls.forEach(el => { el.textContent = n || "Your name"; el.classList.toggle("empty", !n); el.style.fontSize = n.length > 22 ? "4.4cqw" : ""; });
    nameBack.textContent = n || "Your name";
  }
  $("#fullName").addEventListener("input", e => setName(e.target.value));
  $("#make").addEventListener("submit", e => {
    e.preventDefault();
    const n = $("#fullName").value.trim();
    if (!n) { $("#made").textContent = "Enter your full name to put it on your badge."; $("#fullName").focus(); return; }
    setName(n); if (Math.round(target / 180) % 2) target -= 180; sweep();
    if (window.quaSaveName) window.quaSaveName(n);
    $("#made").textContent = "It's yours, " + n.split(/\s+/)[0] + ". Tap the card to see your perks.";
    try { const mine = JSON.parse(localStorage.getItem("qua-duck") || "null"); if (mine) { mine.name = n; localStorage.setItem("qua-duck", JSON.stringify(mine)); } } catch (err) {}
  });

  /* handling the badge: it tilts toward the pointer, turns over on a tap, spins when dragged and settles on a face */
  let spin = 0, target = 0, vel = 0, tx = 0, ty = 0, ttx = 0, tty = 0, dragging = false, start = 0, startSpin = 0, t0 = 0, lastX = 0, lastT = 0, flick = 0, moved = false, touchedAt = 0;
  const setLight = (x, y) => { badge.style.setProperty("--mx", x * 100 + "%"); badge.style.setProperty("--my", y * 100 + "%"); badge.style.setProperty("--sx", 100 - x * 100 + "%"); badge.style.setProperty("--sy", 100 - y * 100 + "%"); };
  badge.addEventListener("pointermove", e => {
    const r = badge.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
    setLight(Math.min(1, Math.max(0, x)), Math.min(1, Math.max(0, y)));
    if (!reduced && e.pointerType === "mouse") { ttx = (.5 - y) * 7; tty = (x - .5) * 9; }
    if (!dragging) return;
    const dx = e.clientX - start; if (Math.abs(dx) > 6) moved = true;
    spin = startSpin + dx * .6;
    const now = performance.now(); flick = (e.clientX - lastX) / Math.max(1, now - lastT) * .6; lastX = e.clientX; lastT = now;
  });
  badge.addEventListener("pointerleave", () => { ttx = 0; tty = 0; });
  badge.addEventListener("pointerdown", e => {
    if (e.button !== 0) return;
    dragging = true; moved = false; start = lastX = e.clientX; startSpin = spin; t0 = lastT = touchedAt = performance.now(); flick = 0;
    badge.setPointerCapture(e.pointerId);
  });
  const release = () => {
    if (!dragging) return; dragging = false;
    if (!moved && performance.now() - t0 < 400) target = Math.round(startSpin / 180) * 180 + 180;
    else target = Math.round((spin + flick * 260) / 180) * 180;
    vel = flick * 16;
    if (reduced) { spin = target; vel = 0; }
  };
  badge.addEventListener("pointerup", release);
  badge.addEventListener("pointercancel", release);
  badge.addEventListener("keydown", e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); target = Math.round(target / 180) * 180 + 180; if (reduced) spin = target; } });

  function frame(t) {
    if (!moment.hidden) {
      if (!dragging) { vel += (target - spin) * .06; vel *= .8; spin += vel; }
      tx += (ttx - tx) * .1; ty += (tty - ty) * .1;
      const amp = 1.2 + 3.8 * Math.exp(-(t - touchedAt) / 2600); // lively after arrival or a touch, then a slow small drift
      const float = reduced || dragging ? 0 : Math.sin(t / 1300) * amp;
      card.style.setProperty("--el", Math.abs(Math.sin((spin + ty) * Math.PI / 180)).toFixed(3)); // the edge brightens side-on
      card.style.transform = `translateY(${float}px) rotateX(${tx}deg) rotateY(${spin + ty}deg)`;
      floor.style.transform = `scale(${1 - float / 60}, 1)`; floor.style.opacity = .9 - float / 25;
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  /* a returning Early Duck (same browser): their own badge, no new number */
  function restore(no, date, name) {
    setNumber(no); if (date) $$("#moment [data-date]").forEach(el => el.textContent = date);
    setName(name || ""); $("#fullName").value = name || "";
    reopen();
  }
  window.quaEarlyDuck = { open, reopen, restore };
})();